var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.lang),expression:"lang"}],attrs:{"id":"app"}},[_c('Header'),_c('Slides'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }